import React from "react";
import {
  Card,
  CardHeader,
  CardBody,
  Progress,
  Badge,
} from "reactstrap";

const StaffWorkloadPanel = ({
  staff = [],
  tasks = [],
}) => {

  const today =
    new Date()
      .toISOString()
      .split("T")[0];

  const normalizeStatus = (status = "") => {
    return status
      .toString()
      .trim()
      .toUpperCase()
      .replace(" ", "_");
  };

  const isAssignedToStaff = (
    task,
    member
  ) => {

    const assignedId =
      typeof task.assignedTo === "object"
        ? task.assignedTo?._id
        : task.assignedTo;

    return (
      assignedId === member._id ||
      task.assignedToName === member.name
    );
  };

  const getStaffMetrics = (member) => {

    const assignedTasks =
      tasks.filter(task =>
        isAssignedToStaff(
          task,
          member
        )
      );

    const assignedToday =
      assignedTasks.filter(task => {

        if (!task.assignedAt)
          return false;

        return (
          new Date(task.assignedAt)
            .toISOString()
            .split("T")[0] === today
        );

      });


    const completed =
      assignedTasks.filter(task =>
        normalizeStatus(task.status) === "COMPLETED"
      );


    const pending =
      assignedTasks.filter(task => {

        const status =
          normalizeStatus(task.status);

        return (
          status === "PENDING" ||
          status === "ASSIGNED" ||
          status === "IN_PROGRESS"
        );

      });


    const currentTask =
      assignedTasks.find(task =>
        normalizeStatus(task.status) === "IN_PROGRESS"
      );


    const productivity =
      assignedTasks.length
        ? Math.round(
            (
              completed.length /
              assignedTasks.length
            ) * 100
          )
        : 0;


    return {
      total: assignedTasks.length,
      assignedToday: assignedToday.length,
      completed: completed.length,
      pending: pending.length,
      currentRoom: currentTask?.roomNumber || "-",
      productivity,
    };

  };


  return (
    <Card className="mb-3 shadow-sm">

      <CardHeader className="fw-bold">
        Housekeeping Team Workload
      </CardHeader>

      <CardBody>

        {
          staff.length === 0 ?

          (
            <div className="text-center text-muted">
              No housekeeping staff found
            </div>
          )

          :

          (
            staff.map(member => {

              const stats =
                getStaffMetrics(member);

              return (

                <div
                  key={member._id}
                  className="mb-4 pb-3 border-bottom"
                >

                  <div className="d-flex justify-content-between align-items-center">

                    <div>

                      <h6 className="mb-1">
                        {member.name}
                      </h6>

                      <small className="text-muted">
                        {member.role || "Housekeeping"}
                      </small>

                    </div>


                    <Badge color="primary">
                      {stats.productivity}%
                    </Badge>

                  </div>


                  <div className="mt-3">

                    <div className="d-flex justify-content-between mb-1">

                      <small>
                        Productivity
                      </small>

                      <small>
                        {stats.productivity}%
                      </small>

                    </div>

                    <Progress
                      value={stats.productivity}
                    />

                  </div>


                  <div className="row mt-3">

                    <div className="col-4">

                      <small className="text-muted">
                        Total Tasks
                      </small>

                      <div className="fw-bold">
                        {stats.total}
                      </div>

                    </div>


                    <div className="col-4">

                      <small className="text-muted">
                        Today
                      </small>

                      <div className="fw-bold">
                        {stats.assignedToday}
                      </div>

                    </div>


                    <div className="col-4">

                      <small className="text-muted">
                        Completed
                      </small>

                      <div className="fw-bold text-success">
                        {stats.completed}
                      </div>

                    </div>

                  </div>


                  <div className="row mt-3">

                    <div className="col-6">

                      <small className="text-muted">
                        Active Tasks
                      </small>

                      <div className="fw-bold text-warning">
                        {stats.pending}
                      </div>

                    </div>


                    <div className="col-6">

                      <small className="text-muted">
                        Current Room
                      </small>

                      <div className="fw-bold">
                        {stats.currentRoom}
                      </div>

                    </div>

                  </div>


                </div>

              );

            })
          )

        }

      </CardBody>

    </Card>
  );
};

export default StaffWorkloadPanel;